function ocerviewText(){
	var $parentBlock = $('.overview__block'),
			$colLeft = $parentBlock.find('.overview__col').first(),
			$colRight = $parentBlock.find('.overview__col').last(),
			$title = $parentBlock.find('h3'),
			$textBlock = $parentBlock.find('.overview__text[data-replace="true"]');

	var moveElems = function(){
		if ($(window).outerWidth() < 1200) {
			if ($title.length == 1) {
				$parentBlock.prepend($title);
			}

			$colLeft.append($textBlock);
		}else{
			$colLeft.prepend($title);
			$colRight.find('.overview__text:nth-child(2)').after($textBlock);
		}
	}
	moveElems();

	$(window).resize(function(){
		moveElems();
	})
}
ocerviewText();

function overviewImage(){
	var $title = $('.overview__inner > img');

	if ($(window).outerWidth() < 768) {
		$title.attr('src', 'assets/img/overview-sm.jpg');
	}else{
		$title.attr('src', 'assets/img/overview.png');
	}
}
overviewImage();

$(window).resize(function(){
	overviewImage();
})